import { Loading } from 'element-ui';
import { getAuth, signInWithRedirect, getRedirectResult, signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { loginWithGoogle } from '@/api/login';
import { siteThemeMixin } from '@/mixins/theme';
import { sleep, queryUrl } from '@/utils/util';
import firebase from '@/firebase';

export default {
  name: 'Login',

  mixins: [siteThemeMixin],

  data() {
    return {
      userName: '',
      password: '',
      code: '',
      loginErrorMsg: '',
      loading: false,
      imgCodeUrl: '/api/code?1',
      loginQRCode: '',
      loginSuccess: false,
      qrcodeTimeout: false,
      appShow: true,
      tagMap: {},
    };
  },

  methods: {
    init() {},

    async loginGoogle() {
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'chat-loading',
        background: '#2f2f2f'
      });

      try {
        const provider = new GoogleAuthProvider();
        const authResult = await signInWithPopup(firebase.auth, provider);
        const user = authResult.user;
        const res = await loginWithGoogle({
          uid: user.uid,
          token: user.accessToken,
        });

        if (res.code !== 0) {
          this.$message({
            message: 'login fail',
            type: 'error'
          });;
          loading.close();
          return;
        }

        await this.$store.dispatch('updateUserInfo');
        this.$message({
          message: 'successful',
          type: 'success',
          customClass: 'custom-message',
        });
        this.$router.push({
          path: '/',
        });
        loading.close();
      }
      catch(err) {
        loading.close();
      }
    },
  },

  mounted() {
    
  }
}